export const logisticAPI = '/logistic';

// /logistic/slots
export const slotsAPI = `${logisticAPI}/slots`;
